export const LOGIN_ROUTE = 'login';

export const HOME_ROUTE = 'home';
export const ACCOUNT_ROUTE = 'account';

export const APPOINTMENTS_ROUTE = 'appointments';
export const APPOINTMENT_DETAIL_PARAM = 'id';
export const APPOINTMENT_APPROVED_ROUTE = 'approved';
export const APPOINTMENT_PENDING_ROUTE = 'requests';
export const APPOINTMENT_DENIED_ROUTE = 'denied';
export const APPOINTMENT_NEW_REQUESTS_ROUTE = 'new-requests';

export const DOCTORS_ROUTE = 'doctors';
export const DOCTORS_ROUTE_LIST = 'doctors-list';
export const DOCTOR_ROUTE = 'doctor';
export const DOCTOR_SEARCH_ROUTE = 'find-doctor';
export const DOCTOR_ROUTE_PARAM = 'doctorUserTag';

export const MESSAGE_DOCTOR_PARAM = 'doctor';
export const MESSAGE_PATIENT_ID_PARAM = 'patientId';
export const CHAT_ROUTE = 'chat';
export const CHAT_PREVIEW_LAB_REQUEST_FILE_ROUTE = 'CHAT_PREVIEW_LAB_REQUEST_FILE_ROUTE';
export const ORDER_CHAT_ROUTE = 'orderChat';
export const ORDER_CHAT_ROUTE_PARAM = 'orderid';
export const MESSAGES_ROUTE = 'messages';
export const MESSAGES_ROUTE_ALL = 'allMessages';
export const DOCTOR_MESSAGES_ROUTE = 'doctorMessages';
export const SERVICE_MESSAGES_ROUTE = 'serviceMessages';

export const FILES_ROUTE = 'files';
export const FILES_ALL_FILES_ROUTE = 'files/all-files';
export const FILES_PRESCRIPTIONS_ROUTE = 'files/prescriptions';
export const FILES_LABTESTS_ROUTE = 'files/labtests';
export const FILES_OTHER_NOTES_ROUTE = 'files/other-notes';

export const BOOKING_ROUTE = 'booking';
export const BOOKING_ROUTE_PARAM = 'doctorUserTag';

export const SERVICES_ROUTE = 'services';
export const SERVICES_FIND_A_SERVICE_PATH = 'find-a-service';
export const SERVICES_FIND_A_SERVICE_ROUTE = 'servicesFindAService';
export const SERVICES_ONGOING_ROUTE = 'servicesOngoing';
export const SERVICES_PAST_ROUTE = 'servicesPast';

export const PHARMACY_FULFILLMENT_MODE = 'fulfillmentMode';
export const PHARMACY_FULFILLMENT_MODE_PARAM = 'channelid';
export const PHARMACY_ORDERS = 'pharmacyOrders';
export const PHARMACY_WATSONS_ORDERS = 'pharmacyWatsonsOrders';
export const PHARMACY_ORDERS_ADD_PRESCRIPTION = 'pharmacyOrdersAddPrescription';
export const MEDICINE_ORDER = 'medicineOrder';
export const MEDICINE_ORDER_ID_PARAM = 'medicineOrderId';
export const MEDICINE_ORDER_PREVIEW_FILE = 'medicineOrderPreviewFile';
export const MEDICINE_ORDER_LAB_REQUESTS = 'medicineOrderLabRequests';
export const PHARMACY_PREVIEW_FILE = 'pharmacyPreviewFile';
export const PREVIEW_FILE = 'previewFile';
export const PREVIEW_FILE_LAB_REQUEST = 'previewFileLabRequest';

export const LAB_REQUESTS = 'labRequests';
export const LAB_REQUESTS_PREVIEW_FILE = 'labRequestsPreviewFile';

export const ERROR_ROUTE = 'error';

export const INVITE_CODE_ROUTE = 'invitecode';

export const CLINIC_QR_ROUTE = 'clinicqr';
export const CLINIC_QR_DOCTOR_PARAM = 'doctorUserId';

export const PROGRAM_ROOT = 'programRoot';

export const ONDEMAND_ROOT = 'onDemandRoot';

export default {
  ACCOUNT_ROUTE,
  APPOINTMENTS_ROUTE,
  APPOINTMENT_DETAIL_PARAM,
  APPOINTMENT_APPROVED_ROUTE,
  APPOINTMENT_PENDING_ROUTE,
  APPOINTMENT_DENIED_ROUTE,
  APPOINTMENT_NEW_REQUESTS_ROUTE,
  BOOKING_ROUTE,
  BOOKING_ROUTE_PARAM,
  DOCTORS_ROUTE,
  DOCTORS_ROUTE_LIST,
  DOCTOR_SEARCH_ROUTE,
  DOCTOR_ROUTE,
  DOCTOR_ROUTE_PARAM,
  ERROR_ROUTE,
  HOME_ROUTE,
  INVITE_CODE_ROUTE,
  CLINIC_QR_ROUTE,
  CLINIC_QR_DOCTOR_PARAM,
  LOGIN_ROUTE,
  MESSAGE_DOCTOR_PARAM,
  MESSAGE_PATIENT_ID_PARAM,
  MESSAGES_ROUTE,
  MESSAGES_ROUTE_ALL,
  DOCTOR_MESSAGES_ROUTE,
  SERVICE_MESSAGES_ROUTE,
  CHAT_ROUTE,
  CHAT_PREVIEW_LAB_REQUEST_FILE_ROUTE,
  ORDER_CHAT_ROUTE,
  ORDER_CHAT_ROUTE_PARAM,
  PHARMACY_ORDERS,
  PHARMACY_WATSONS_ORDERS,
  PHARMACY_ORDERS_ADD_PRESCRIPTION,
  MEDICINE_ORDER_PREVIEW_FILE,
  PHARMACY_PREVIEW_FILE,
  PREVIEW_FILE,
  PREVIEW_FILE_LAB_REQUEST,
  MEDICINE_ORDER,
  MEDICINE_ORDER_ID_PARAM,
  MEDICINE_ORDER_LAB_REQUESTS,
  FILES_ROUTE,
  FILES_ALL_FILES_ROUTE,
  FILES_PRESCRIPTIONS_ROUTE,
  FILES_LABTESTS_ROUTE,
  FILES_OTHER_NOTES_ROUTE,
  SERVICES_ROUTE,
  SERVICES_FIND_A_SERVICE_PATH,
  SERVICES_FIND_A_SERVICE_ROUTE,
  PHARMACY_FULFILLMENT_MODE,
  PHARMACY_FULFILLMENT_MODE_PARAM,
  SERVICES_ONGOING_ROUTE,
  SERVICES_PAST_ROUTE,
  LAB_REQUESTS,
  LAB_REQUESTS_PREVIEW_FILE,
  PROGRAM_ROOT,
  ONDEMAND_ROOT,
}